import type { Overwrite } from "@mui/types";

import { fbSdk } from "@/lib/fbSdk";

type UseFbIgLoginOptions = Overwrite<
  Parameters<typeof fbSdk.hooks.mutations.useLoginMutation>[0],
  {
    onSuccess?: (data: {
      authResponse: {
        code: string;
      };
    }) => void;
  }
>;

export function useFacebookLogin(options?: UseFbIgLoginOptions) {
  const loginMutation = fbSdk.hooks.mutations.useLoginMutation({
    ...options,
    onSuccess: async (data) => {
      if (data.status !== "connected" || !data.authResponse?.code) {
        return;
      }
      options?.onSuccess?.({
        authResponse: {
          code: data.authResponse.code,
        },
      });
    },
  });

  const startLogin = (loginOptions?: facebook.LoginOptions) => {
    loginMutation.mutate({
      loginOptions: {
        response_type: "code",
        override_default_response_type: true,
        ...loginOptions,
      },
    });
  };

  return Object.assign(loginMutation, {
    startLogin,
  });
}
